(function () {
	'use strict';

	angular.module('dcApp').directive('elementToDuplicate', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'$rootScope',
				'$timeout',
				'elem',
				function ($scope, $rootScope, $timeout, elem) {
					var vm = this;

					var LOCKED_ELEMENT_TYPES = [
						elem.type.dashboard,
						elem.type.hdElements,
						elem.type.sharedElements,
						elem.type.datablock,
						elem.type.entity,
						elem.type.repository,
						elem.type.exportTemplate,
						elem.type.connector,
					];

					vm.elem = elem;
					vm.init = init;
					vm.toggleElementType = toggleElements;

					function toggleElements(type) {
						if (type === vm.elem.type.datablock) {
							vm.elementTypes.datablock.checked === true
								? toggleAssociatedElements(
										vm.elementTypes[vm.elem.type.datablock].checked,
										[vm.elem.type.entity]
								  )
								: toggleAssociatedElements(false, [
										vm.elem.type.hdElements,
										vm.elem.type.dashboard,
										vm.elem.type.sharedElements,
								  ]);
							$scope.$emit(
								'elementToDuplicate:sharedElements:selection',
								vm.elementTypes[vm.elem.type.sharedElements].checked
							);
						} else if (
							type === vm.elem.type.dashboard &&
							vm.elementTypes.dashboard.checked === true
						) {
							toggleAssociatedElements(
								vm.elementTypes[vm.elem.type.dashboard].checked,
								[
									vm.elem.type.hdElements,
									vm.elem.type.datablock,
									vm.elem.type.entity,
								]
							);
						} else if (type === vm.elem.type.hdElements) {
							vm.elementTypes.hdElements.checked === true
								? toggleAssociatedElements(
										vm.elementTypes[vm.elem.type.hdElements].checked,
										[vm.elem.type.datablock, vm.elem.type.entity]
								  )
								: toggleAssociatedElements(false, [vm.elem.type.dashboard]);
						} else if (
							type === vm.elem.type.connector &&
							vm.elementTypes.connector.checked === false
						) {
							toggleAssociatedElements(false, [
								vm.elem.type.repository,
								vm.elem.type.exportTemplate,
								vm.elem.type.localData,
								vm.elem.type.extractRepository,
							]);
						} else if (
							type === vm.elem.type.entity &&
							vm.elementTypes.entity.checked === false
						) {
							toggleAssociatedElements(false, [
								vm.elem.type.datablock,
								vm.elem.type.hdElements,
								vm.elem.type.dashboard,
								vm.elem.type.entity,
								vm.elem.type.sharedElements,
							]);
							$scope.$emit(
								'elementToDuplicate:sharedElements:selection',
								vm.elementTypes[vm.elem.type.sharedElements].checked
							);
						} else if (type === vm.elem.type.sharedElements) {
							// makes datablock & entity checked
							if (vm.elementTypes.sharedElements.checked) {
								toggleAssociatedElements(
									vm.elementTypes.sharedElements.checked,
									[vm.elem.type.datablock, vm.elem.type.entity]
								);
							}
							$scope.$emit(
								'elementToDuplicate:sharedElements:selection',
								vm.elementTypes[vm.elem.type.sharedElements].checked
							);
						} else if (type === vm.elem.type.repository) {
							vm.elementTypes.repository.checked === true
								? toggleAssociatedElements(
										vm.elementTypes[vm.elem.type.repository].checked,
										[vm.elem.type.connector]
								  )
								: toggleAssociatedElements(false, [
										vm.elem.type.extractRepository,
										vm.elem.type.localData,
								  ]);
						} else if (
							type === vm.elem.type.exportTemplate &&
							vm.elementTypes.exportTemplate.checked === true
						) {
							toggleAssociatedElements(
								vm.elementTypes[vm.elem.type.exportTemplate].checked,
								[vm.elem.type.connector]
							);
						} else if (
							type === vm.elem.type.extractRepository &&
							vm.elementTypes.extractRepository.checked === true
						) {
							toggleAssociatedElements(
								vm.elementTypes[vm.elem.type.extractRepository].checked,
								[vm.elem.type.repository, vm.elem.type.connector]
							);
						} else if (
							type === vm.elem.type.localData &&
							vm.elementTypes.localData.checked === true
						) {
							toggleAssociatedElements(
								vm.elementTypes[vm.elem.type.localData].checked,
								[vm.elem.type.repository, vm.elem.type.connector]
							);
						} else if (type === vm.elem.type.noneContext) {
							toggleAssociatedElements(false, [
								vm.elem.type.extractRepository,
								vm.elem.type.localData,
							]);
							vm.disabled = true;
						} else if (type === vm.elem.type.sameContext) {
							vm.disabled = false;
						}
					}

					function toggleAssociatedElements(state, elements) {
						elements.forEach((el) => {
							vm.elementTypes[el].checked = state;
						});
					}

					function lockImportedElements() {
						LOCKED_ELEMENT_TYPES.forEach(function (type) {
							vm.elementTypes[type].checked = true;
						});
						$scope.$emit(
							'elementToDuplicate:sharedElements:selection',
							vm.elementTypes[vm.elem.type.sharedElements].checked
						);
					}

					function init() {
						vm.initialElementsState = {
							datablock: { checked: false },
							dashboard: { checked: false },
							hdElements: { checked: false },
							sharedElements: { checked: false },
							entity: { checked: false },
							repository: { checked: false },
							exportTemplate: { checked: false },
							connector: { checked: false },
							extractRepository: { checked: false },
							localData: { checked: false },
						};
						vm.elementTypes =
							vm.elementTypes && Object.keys(vm.elementTypes).length !== 0
								? vm.elementTypes
								: vm.initialElementsState;
						$scope.selectedItem = null;
						$scope.autocompleteDemoRequireMatch = false;

						// La directive existe des l'ouverture du modal : on attend que les
						// stats de l'archive soient chargees avant de verrouiller, sinon
						// l'evenement partirait avec des compteurs encore vides.
						$scope.$watchGroup(
							[
								function () {
									return vm.isNewVersion;
								},
								function () {
									return vm.data ? vm.data.sharedElements : undefined;
								},
							],
							function ([isNewVersion, sharedElements]) {
								if (isNewVersion && sharedElements) {
									lockImportedElements();
								}
							}
						);
					}
				},
			];

			return buildDirectiveReturnObject(
				{
					data: '=',
					elementTypes: '=',
					disabled: '=',
					from: '=',
					isNewVersion: '=',
					projectToImportInfos: '=',
					usage: '<',
				},
				controller,
				'./src/components/directives/duplicateProject/elementToDuplicate.html',
				function postLink(scope, element, attrs, $ctrl) {
					$ctrl.init();

					initElementForDirective(element, attrs, function () {});

					watchElementForDirective(
						element,
						scope,
						function () {
							return $ctrl.data ? $ctrl.data.showExportDatablock : false;
						},
						function () {},
						true
					);
				}
			);
		},
	]);
})();
